import { render, staticRenderFns } from "./ColumnTransactionStatusCelcoin.vue?vue&type=template&id=1de11faf&scoped=true"
import script from "./ColumnTransactionStatusCelcoin.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusCelcoin.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusCelcoin.vue?vue&type=style&index=0&id=1de11faf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de11faf",
  null
  
)

export default component.exports